// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericSwitch_container__R3f2J","box":"GenericSwitch_box__CAF9b","text":"GenericSwitch_text__arvTE","switch":"GenericSwitch_switch___msHr"};